export default class UnitType {
    id = 1;
    name = '';
}